const delay = 6000;

const elements = document.querySelectorAll('.js-rotate');
Array.from(elements).forEach(element => {
  const items = element.children;
  const count = items.length;
  let currentIndex = 0;

  if (count > 1) {
    setInterval(() => {
      items[currentIndex].classList.remove('is-active');

      currentIndex = currentIndex >= count - 1 ? 0 : currentIndex + 1;
      items[currentIndex].classList.add('is-active');
    }, delay);
  }
});
